import React from 'react';
import { Box, Button, Grid, Paper, TextField, Typography } from "@mui/material";

export default function WorkSection() {
  return (
    <>
        <Box
          container
          sx={{
            display: "flex",
            flexDirection: "column",
            // justifyContent: "center",
            alignItems: "center",
            marginTop: "90.03px",
            // border:"1px solid red"
          }}
        >
          <Box>
            <Typography
              sx={{
                justifyContent: "center",
                textAlign: "center",
                fontSize:  {lg: "40px", md: "40px", sm: "30px", xs: "25px"},
                fontWeight: "600",
                lineHeight: {lg: "56px", md: "56px", sm: "56px", xs: "40px"},
              }}
            >
              How It Works ?
            </Typography>
          </Box>

          <Box sx={{ marginTop: "64px" }}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={4} md={4} lg={4}>
                <Box sx={{
                  display:'flex',
                  flexDirection:'row',
                  alignItems:'center'
                }}>
                  
                  <Box>
                  <Box>
                    <img
                      src="./images/HeartSearchIcon.svg"
                      alt=""
                      width={"56px"}
                      height={"56px"}
                    />
                  </Box>
                  <Box>
                    <Typography
                      sx={{
                        // width: "203px",
                        height: "30px",
                        fontWeight: "600",
                        fontSize: {lg: "24px", md: "24px", sm: "14px", xs: "20px"},
                        lineHeight: "30px",
                        color: "#1A1824",
                        // width: "282px",
                        // height: "40px",
                      }}
                    >
                      Choose Meal Plans
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: {lg: "14px", md: "14px", sm: "10px", xs: "12px"},
                        fontWeight: "400",
                        lineHeight: "19.6px",
                        letterSpacing: "0.015em",
                        color: "#545359",
                        width: {lg: "282px", md: "282px", sm: "140px"},
                        // width: "282px",
                        // height: "40px",
                      }}
                    >
                      Lorem Ipsum is simply dummy text of the  printing
                      and typesetting industry.
                    </Typography>
                  </Box>
                  <Box >
                    <Box sx={{
                      width: {lg: "282px", md: "282px", sm: "148px", xs: "100%"}
                    }}>
                      <img src="./images/BlueProgressline.svg" alt="" width="100%" />
                    </Box>
                  </Box>
                  </Box>

                  <Box sx={{
                    display:{lg:'block',md:'block',sm:'block',xs:'none'},
                    // paddingLeft: {lg: "22px", md: "22px", sm: "0px", xs: "0px"},
                    width: {lg: "149px", md: "149px", sm: "100px", xs: "100%"}
                  }}>
                    <img src="./images/Progressline.svg" alt="" width="100%" />
                  </Box>

                </Box>
              </Grid>
              
              <Grid item xs={12} sm={4} md={4} lg={4} >
                <Box sx={{
                  display:'flex',
                  flexDirection:'row',
                  alignItems:'center',
                  // paddingLeft: {lg: "20px", md: "0px", sm: "0px", xs: "0px"},
                  // paddingRight: {lg: "40px", md: "0px", sm: "0px", xs: "0px"}
                }}>
                  
                  <Box>
                  <Box>
                    <img
                      src="./images/OrderTypeIcon.svg"
                      alt=""
                      width={"56px"}
                      height={"56px"}
                    />
                  </Box>
                  <Box>
                    <Typography
                      sx={{
                        // width: "203px",
                        // height: "30px",
                        fontWeight: "600",
                        fontSize: {lg: "24px", md: "24px", sm: "14px", xs: "20px"},
                        lineHeight: "30px",
                        color: "#1A1824",
                        // width: "282px",
                        // height: "40px",
                      }}
                    >
                      Select Order Type
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: {lg: "14px", md: "14px", sm: "10px", xs: "12px"},
                        fontWeight: "400",
                        lineHeight: "19.6px",
                        letterSpacing: "0.015em",
                        color: "#545359",
                        width: {lg: "282px", md: "282px", sm: "140px"},
                        // height: "40px",
                      }}
                    >
                      Lorem Ipsum is simply dummy text of the  printing
                      and typesetting industry.
                    </Typography>
                  </Box>
                  <Box >
                    <Box sx={{
                      width: {lg: "282px", md: "282px", sm: "148px", xs: "100%"}
                    }}>
                      <img src="./images/RedUnderlined.svg" alt="" width="100%"/>
                    </Box>
                  </Box>
                  </Box>

                  <Box sx={{
                    display:{lg:'block',md:'block',sm:'block',xs:'none'},
                    // paddingLeft: {lg: "22px", md: "22px", sm: "0px", xs: "0px"},
                    width: {lg: "149px", md: "149px", sm: "100px", xs: "100%"}
                    
                    
                  }}>
                    <img src="./images/Progressline.svg" alt="" width="100%" />
                  </Box>

                </Box>
              </Grid>

              <Grid item xs={12} sm={4} md={4} lg={4}>
                <Box sx={{
                  display:'flex',
                  flexDirection:'row',
                  alignItems:'center',
                  // paddingLeft: {lg: "40px", md: "0px", sm: "0px", xs: "0px"}
                }}>
                  
                  <Box>
                  <Box>
                    <img
                      src="./images/VehicleIcon.svg"
                      alt=""
                      width={"56px"}
                      height={"56px"}
                    />
                  </Box>
                  <Box>
                    <Typography
                      sx={{
                        // width: "203px",
                        height: "30px",
                        fontWeight: "600",
                        fontSize: {lg: "24px", md: "24px", sm: "14px", xs: "20px"},
                        lineHeight: "30px",
                        color: "#1A1824",
                        // width: "282px",
                        // height: "40px",
                      }}
                    >
                      Delivered To You
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: {lg: "14px", md: "14px", sm: "10px", xs: "12px"},
                        fontWeight: "400",
                        lineHeight: "19.6px",
                        letterSpacing: "0.015em",
                        color: "#545359",
                        // width: "282px",
                        width: {lg: "282px", md: "282px", sm: "140px"},
                        // height: "40px",
                      }}
                    >
                      Lorem Ipsum is simply dummy text of the  printing
                      and typesetting industry.
                    </Typography>
                  </Box>
                  <Box >
                    <Box sx={{
                      width: {lg: "282px", md: "282px", sm: "148px", xs: "100%"}
                    }}>
                      <img src="./images/LightblueUnderline.svg" alt="" width="100%" />
                    </Box>
                  </Box>
                  </Box>

                  {/* <Box>
                    <img src="./images/Progressline.svg" alt="" />
                  </Box> */}

                </Box>
              </Grid>
              
            </Grid>
          </Box>
        </Box>
    </>
  )
}
